import React, { useEffect, useState } from "react";

export const formatTime = (seconds) => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
};


const CountdownTimer = ({ startTime, waitSeconds, currentTime, onComplete }) => {
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (!startTime || !waitSeconds) return;

    const start = new Date(startTime).getTime();
    const end = start + waitSeconds * 1000;
    let simulatedNow = currentTime
      ? new Date(currentTime).getTime()
      : Date.now();

    const updateCountdown = () => {
      const diff = Math.max(0, Math.floor((end - simulatedNow) / 1000));
      setTimeLeft(diff);
      simulatedNow += 1000;

      if (diff <= 0 && typeof onComplete === "function") {
        onComplete();
      }
    };

    updateCountdown(); 
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval); 
  }, [startTime, waitSeconds, currentTime, onComplete]);

  return <span className="text-red-500 font-bold">{formatTime(timeLeft)}</span>;
};

export default CountdownTimer;
